import { Button } from "@core/button";
import { AlertTriangle, RefreshCcw } from "lucide-react";
import { Text } from "@core/index";
const ErrorComponent = ({
  title,
  description,
  retryButton,
  refetch,
}: {
  title: string;
  description: string;
  retryButton: string;
  refetch: () => void;
}) => {
  return (
    <div className="min-h-[400px] flex flex-col items-center justify-center p-8">
      <div className="relative">
        <div className="absolute inset-0 bg-red-500/20 dark:bg-red-500/10 blur-xl rounded-full" />
        <div className="relative bg-white/90 dark:bg-gray-800/90 rounded-2xl p-8 shadow-xl border border-red-100 dark:border-red-900">
          <div className="flex flex-col items-center text-center space-y-4">
            <div className="p-4 bg-red-100 dark:bg-red-900/50 rounded-full animate-bounce-slow">
              <AlertTriangle
                size={32}
                className="text-red-600 dark:text-red-400"
              />
            </div>
            <Text variant={"h2"} className="!text-red-600 dark:!text-red-400">
              {title}
            </Text>
            <Text variant="p" status="subtle" className="max-w-md">
              {description}
            </Text>
            <Button
              variant="solid"
              size="md"
              rounded="lg"
              bgColor="bg-red-100 hover:bg-red-200 dark:bg-red-900/50 dark:hover:bg-red-900/70"
              textColor="text-red-600 dark:text-red-400"
              className="group"
              leftIcon={
                <RefreshCcw
                  size={16}
                  className="group-hover:rotate-180 transition-transform duration-500"
                />
              }
              onClick={() => refetch()}
            >
              {retryButton}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorComponent;
